

































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { isManagementDeckTemplate } from "./data/pdf/aggregation-timeframes";
import { pdf_state } from "./data/pdf/state.pdf";
import { Ref, ref, computed } from "@vue/composition-api";
import { ReportTemplate } from "./data/pdf/model";
import { SharedState } from "@/common/state";
import { getInfoType } from "@/common/state/infotypes";
export default Vue.extend({
  components: { Modal },
  props: ["modalData"],
  setup(_, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "55rem",
      withTopRightCloseBtn: true,
    };
    /**
     * The management decks are excluded: they render a whole report from one
     * section, so there is nothing here to compose, and the aggregation this
     * flow applies duplicated their pages. They live in Executive Reports,
     * which is the surface for ready-made reports with only a period to pick.
     */
    const all_templates = computed(() =>
      pdf_state.report_templates.items.value.filter(
        (t) => !isManagementDeckTemplate(t)
      )
    );

    // we know for sure that there is at least one template
    const selected_template: Ref<ReportTemplate> = ref(all_templates.value[0]);

    const get_info_type_restrictions_for_selected_template = (): string[] => {
      const sections_with_param_values = selected_template.value.sections.filter(
        (f) =>
          f.parameters_values && Object.keys(f.parameters_values).length > 0
      );
      // we are left with only uniq info type ids
      const uniq_info_type_ids_in_template = Array.from(
        new Set(
          sections_with_param_values
            .map((d) =>
              // @ts-ignore
              Object.values(d.parameters_values!).map((f) => Object.values(f))
            )
            .flat(2)
            .filter((val) => getInfoType(val))
        )
      );

      const info_type_restrictions = uniq_info_type_ids_in_template
        .filter((info_type_id) => {
          const { code } = getInfoType(info_type_id)!;
          return SharedState.restrictions.is_restricted_info(code);
        })
        .map((id) => {
          const { labelName } = getInfoType(id)!;
          return labelName;
        });

      console.log("has_info_type_restrictions", info_type_restrictions);
      return info_type_restrictions;
    };

    const create_from_template = () => {
      if (SharedState.is_biz_user.value) {
        const restrictions = get_info_type_restrictions_for_selected_template();
        if (restrictions.length > 0) {
          // show restrictions modal
          SharedState.restrictions.show_restrictions_modal(
            "info",
            restrictions.join(", ")
          );
        } else {
          emit("submit", selected_template.value);
        }
      } else {
        emit("submit", selected_template.value);
      }
    };
    const create_new = () => {
      emit("submit", "new");
    };
    return {
      config,
      all_templates,
      selected_template,
      create_from_template,
      create_new,
    };
  },
});
